export default function SelectionToolbar({
  selectedCount,
  selectedDate,
  todayIso,
  tomorrowIso,
  showOtherDatePicker,
  onToggleOtherDate,
  onOtherDateChange,
  onSetStatus,
  onMoveToDate,
  onPrintMonth,
  onPrintBlankMonth,
  onPrintYear,
  onExport,
  onDelete,
  onClear,
}) {
  const disabled = selectedCount === 0;
  const label = disabled
    ? 'Aucune tâche sélectionnée'
    : `${selectedCount} tâche${selectedCount > 1 ? 's' : ''} sélectionnée${selectedCount > 1 ? 's' : ''}`;

  return (
    <div className={`selection-toolbar ${selectedCount > 0 ? 'floating' : ''}`}>
      <div className="selection-toolbar-left">
        <span className="selection-count">{label}</span>
      </div>

      <div className="selection-toolbar-actions">
        <button type="button" className="selection-action-btn" onClick={() => onSetStatus('todo')} disabled={disabled}>À faire</button>
        <button type="button" className="selection-action-btn" onClick={() => onSetStatus('done')} disabled={disabled}>Fait</button>
        <button type="button" className="selection-action-btn" onClick={() => onMoveToDate(todayIso)} disabled={disabled}>Aujourd'hui</button>
        <button type="button" className="selection-action-btn" onClick={() => onMoveToDate(tomorrowIso)} disabled={disabled}>Demain</button>

        <div className={`selection-other-date ${showOtherDatePicker ? 'open' : ''}`}>
          <button type="button" className="selection-action-btn" onClick={onToggleOtherDate} disabled={disabled}>Autre date</button>
          {showOtherDatePicker && !disabled && (
            <input
              type="date"
              className="selection-other-date-input"
              defaultValue={selectedDate || todayIso}
              onChange={onOtherDateChange}
            />
          )}
        </div>

        <button type="button" className="selection-export-btn selection-print-btn" onClick={onPrintMonth}>PDF mois</button>
        <button type="button" className="selection-export-btn selection-print-btn" onClick={onPrintBlankMonth}>PDF mois vierge</button>
        <button type="button" className="selection-export-btn selection-print-btn" onClick={onPrintYear}>PDF année</button>
        <button type="button" className="selection-export-btn" onClick={onExport} disabled={disabled}>Export JSON</button>
        <button type="button" className="selection-delete-btn" onClick={onDelete} disabled={disabled}>Supprimer</button>
        <button type="button" className="selection-clear-btn" onClick={onClear} disabled={disabled}>Vider</button>
      </div>
    </div>
  );
}
